<div class="d-flex flex-row mt-3 ml-3">
  <img class="logo"
  [src]="styleCocheSeguro.srcLogo"
  (click)="inicio()">
</div>
<div class="container mt-5" >
  <div class="column text-center mb-5">
        <h1 class="title">{{proceso}}</h1>
        <p class="txt">Ya puedes ver tu poliza desde el apartado de "Mis seguros" desde el App <a class="link col-blue" href="https://inter.mx/">INTER.mx</a></p>
        <img class="mt-3 mb-3"
        src="../../assets/images/check-badge.svg" />
        <p class="num">No. Póliza </p>
        <p class="num">{{polizaID}}</p>
        <p class="info-download mt-5">{{(cia.toString() != '3' ? 'Descarga tu póliza' : '')}} 
          <a class="link col-pink" (click)="descargarPoliza()">{{(cia.toString() != '3' ? 'aquí' : '')}}</a>
        </p>
        <p class="info-download mt-5"> {{(cia.toString() == '44' ? 'Descarga tu(s) recibo(s)' : '')}} 
          <a class="link col-pink" (click)="descargarRecibo()">{{(cia.toString() == '44' ? 'aquí' : '')}}</a>
        </p>
        <p class="info" >{{(cia.toString() == '44' ? '' : 'También recibirás una copia a ' + correo)}}</p>
        <p class="txt1" >{{(cia.toString() == '44' ? '' : 'En caso de siniestro llama al:')}}</p>
        <p class="num" >{{(cia.toString() == '44' ? '' : tel_aseg)}}</p>
        <p class="txt1">Para información de tu póliza llama al:</p>
        <p class="num">55442 46837</p>
        <p class="txt1">Horarios de atención:</p>
        <p class="txt1">Lunes a domingo de 8:00 a 20:00</p>
</div>
</div>





